export default __webpack_public_path__ + "static/media/Animations_Bar1.e3b46819.svg";